<template>
  <div class="upsellInfoWrapper">
    <div class="upsellInfo">
      <p class="upsellName">{{ pickListItem.name }}</p>
      <p class="upsellPrice">
      <span v-if="isPriceVisible">
        {{ formatPrice(pickListItem.baseprice) }}
      </span>
      </p>
    </div>
    <div 
      class="upsellItemAddBtn"
      @click="$emit('itemClicked', pickListItem)"
    >
      <template v-if="!selectedOrderItemIds.includes(pickListItem.itemid)">
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
        <path 
          d="M12.4287 25.4302C10.7523 25.4302 9.1735 25.1087 7.69238 24.4658C6.2194 23.8311 4.91732 22.9521 3.78613 21.8291C2.66309 20.6979 1.78011 19.3958 1.13721 17.9229C0.502441 16.4417 0.185059 14.863 0.185059 13.1865C0.185059 11.5101 0.502441 9.93538 1.13721 8.4624C1.78011 6.98128 2.66309 5.6792 3.78613 4.55615C4.90918 3.42497 6.20719 2.54199 7.68018 1.90723C9.1613 1.26432 10.7401 0.942871 12.4165 0.942871C14.0929 0.942871 15.6717 1.26432 17.1528 1.90723C18.634 2.54199 19.936 3.42497 21.0591 4.55615C22.1821 5.6792 23.0651 6.98128 23.708 8.4624C24.3509 9.93538 24.6724 11.5101 24.6724 13.1865C24.6724 14.863 24.3509 16.4417 23.708 17.9229C23.0651 19.3958 22.1821 20.6979 21.0591 21.8291C19.936 22.9521 18.634 23.8311 17.1528 24.4658C15.6799 25.1087 14.1051 25.4302 12.4287 25.4302ZM12.4287 23.8555C13.9017 23.8555 15.2811 23.5788 16.5669 23.0254C17.8608 22.472 18.9961 21.707 19.9727 20.7305C20.9574 19.7539 21.7223 18.6227 22.2676 17.3369C22.821 16.043 23.0977 14.6595 23.0977 13.1865C23.0977 11.7135 22.821 10.3341 22.2676 9.04834C21.7142 7.75439 20.9492 6.61914 19.9727 5.64258C18.9961 4.65788 17.8608 3.8929 16.5669 3.34766C15.2811 2.79427 13.8976 2.51758 12.4165 2.51758C10.9435 2.51758 9.56006 2.79427 8.26611 3.34766C6.98031 3.8929 5.84912 4.65788 4.87256 5.64258C3.90413 6.61914 3.14323 7.75439 2.58984 9.04834C2.0446 10.3341 1.77197 11.7135 1.77197 13.1865C1.77197 14.6595 2.0446 16.043 2.58984 17.3369C3.14323 18.6227 3.9082 19.7539 4.88477 20.7305C5.86133 21.707 6.99251 22.472 8.27832 23.0254C9.56413 23.5788 10.9476 23.8555 12.4287 23.8555ZM6.87451 13.1865C6.87451 12.9505 6.94775 12.7593 7.09424 12.6128C7.24072 12.4663 7.43604 12.3931 7.68018 12.3931H11.6353V8.42578C11.6353 8.18978 11.7085 7.99854 11.855 7.85205C12.0015 7.69743 12.1846 7.62012 12.4043 7.62012C12.6403 7.62012 12.8315 7.69336 12.978 7.83984C13.1245 7.98633 13.1978 8.18164 13.1978 8.42578V12.3931H17.1772C17.4051 12.3931 17.5923 12.4663 17.7388 12.6128C17.8853 12.7593 17.9585 12.9505 17.9585 13.1865C17.9585 13.4062 17.8853 13.5894 17.7388 13.7358C17.5923 13.8742 17.4051 13.9434 17.1772 13.9434H13.1978V17.9229C13.1978 18.1589 13.1245 18.3501 12.978 18.4966C12.8315 18.6431 12.6403 18.7163 12.4043 18.7163C12.1846 18.7163 12.0015 18.6431 11.855 18.4966C11.7085 18.342 11.6353 18.1507 11.6353 17.9229V13.9434H7.68018C7.44417 13.9434 7.24886 13.8742 7.09424 13.7358C6.94775 13.5894 6.87451 13.4062 6.87451 13.1865Z" fill="#737373"/>
        </svg>
      </template>
      <template v-else>
        <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.4287 25.4302C10.7523 25.4302 9.1735 25.1087 7.69238 24.4658C6.2194 23.8311 4.91732 22.9521 3.78613 21.8291C2.66309 20.6979 1.78011 19.3958 1.13721 17.9229C0.502441 16.4417 0.185059 14.863 0.185059 13.1865C0.185059 11.5101 0.502441 9.93538 1.13721 8.4624C1.78011 6.98128 2.66309 5.6792 3.78613 4.55615C4.90918 3.42497 6.20719 2.54199 7.68018 1.90723C9.1613 1.26432 10.7401 0.942871 12.4165 0.942871C14.0929 0.942871 15.6717 1.26432 17.1528 1.90723C18.634 2.54199 19.936 3.42497 21.0591 4.55615C22.1821 5.6792 23.0651 6.98128 23.708 8.4624C24.3509 9.93538 24.6724 11.5101 24.6724 13.1865C24.6724 14.863 24.3509 16.4417 23.708 17.9229C23.0651 19.3958 22.1821 20.6979 21.0591 21.8291C19.936 22.9521 18.634 23.8311 17.1528 24.4658C15.6799 25.1087 14.1051 25.4302 12.4287 25.4302ZM12.4287 23.8555C13.9017 23.8555 15.2811 23.5788 16.5669 23.0254C17.8608 22.472 18.9961 21.707 19.9727 20.7305C20.9574 19.7539 21.7223 18.6227 22.2676 17.3369C22.821 16.043 23.0977 14.6595 23.0977 13.1865C23.0977 11.7135 22.821 10.3341 22.2676 9.04834C21.7142 7.75439 20.9492 6.61914 19.9727 5.64258C18.9961 4.65788 17.8608 3.8929 16.5669 3.34766C15.2811 2.79427 13.8976 2.51758 12.4165 2.51758C10.9435 2.51758 9.56006 2.79427 8.26611 3.34766C6.98031 3.8929 5.84912 4.65788 4.87256 5.64258C3.90413 6.61914 3.14323 7.75439 2.58984 9.04834C2.0446 10.3341 1.77197 11.7135 1.77197 13.1865C1.77197 14.6595 2.0446 16.043 2.58984 17.3369C3.14323 18.6227 3.9082 19.7539 4.88477 20.7305C5.86133 21.707 6.99251 22.472 8.27832 23.0254C9.56413 23.5788 10.9476 23.8555 12.4287 23.8555ZM11.0981 18.9727C10.9435 18.9727 10.8011 18.9401 10.6709 18.875C10.5488 18.8018 10.4308 18.6919 10.3169 18.5454L7.04541 14.627C6.89893 14.4235 6.82568 14.2282 6.82568 14.041C6.82568 13.8376 6.89486 13.6626 7.0332 13.5161C7.17969 13.3696 7.35059 13.2964 7.5459 13.2964C7.68424 13.2964 7.80632 13.3249 7.91211 13.3818C8.02604 13.4307 8.1359 13.5243 8.2417 13.6626L11.0615 17.1416L16.5913 8.40137C16.7703 8.12467 16.9901 7.98633 17.2505 7.98633C17.4458 7.98633 17.6208 8.05143 17.7754 8.18164C17.93 8.31185 18.0073 8.47868 18.0073 8.68213C18.0073 8.77979 17.9829 8.88151 17.9341 8.9873C17.8934 9.08496 17.8446 9.17855 17.7876 9.26807L11.855 18.5454C11.6597 18.8302 11.4074 18.9727 11.0981 18.9727Z" fill="#FF2D1E"/>
        </svg>
      </template>
    </div>
  </div>
</template>

<script>
  import formattingMixins from '@/mixins/formattingMixins'

  export default {
    mixins: [formattingMixins]
  }
</script>

<script setup>

  import { computed, defineProps } from 'vue'

  const props = defineProps({
    orderData: {
      type: Object,
      default: () => {},
    },
    pickListItem: {
      type: Object,
      default: () => {}
    },
    isPriceVisible: {
      type: Boolean,
      default: false
    }
  })

  const selectedOrderItemIds = computed(() => {
    return props.orderData.order.items.reduce((itemIds, item) => {
      itemIds.push(item.item_id)
      return itemIds
    }, [])
  })

</script>

<style lang="css" scoped>
  .upsellInfoWrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .upsellInfo {
    max-width: 129px;
  }
  .upsellName {
    font-family: var(--regular-bold-font);
    font-size: 16px;
    margin-bottom: 10px;
    line-height: 1.3;
    color: var(--header-text-color);
  }

  .upsellItemAddBtn {
    cursor: pointer;
  }

  svg path {
    fill: var(--primary-color);
  }
</style>
